export const categories = [
  {
    id: "movie",
    name: "电影",
    icon: "ri-movie-2-line",
    tagline: "院线大片与经典佳作",
    description:
      "汇集动作、科幻、剧情、冒险等多种题材的电影作品，涵盖国内外近年热门影片，支持按地区、年份与清晰度快速筛选。",
  },
  {
    id: "tv",
    name: "电视剧",
    icon: "ri-tv-2-line",
    tagline: "连续剧与剧集精选",
    description:
      "都市、悬疑、古装、职场等类型剧集一站式聚合，按更新节奏整理，方便连续追看与快速定位整季资源。",
  },
  {
    id: "variety",
    name: "综艺",
    icon: "ri-mic-line",
    tagline: "综艺节目与真人秀",
    description:
      "音乐竞技、美食、旅行等热门综艺节目聚合，直观展示每期亮点与看点，方便按主题挑选想看的节目。",
  },
  {
    id: "anime",
    name: "动漫",
    icon: "ri-emotion-happy-line",
    tagline: "番剧与动画作品",
    description:
      "奇幻、机战、日常等动画作品与番剧聚合，整理分集信息与作品简介，帮助动画爱好者按口味检索。",
  },
  {
    id: "documentary",
    name: "纪录片",
    icon: "ri-earth-line",
    tagline: "自然与人文纪实",
    description:
      "聚焦自然、宇宙、历史与人文的纪录片聚合，呈现高质量影像内容，适合沉浸式观看与知识拓展。",
  },
  {
    id: "sports",
    name: "体育",
    icon: "ri-basketball-line",
    tagline: "赛事集锦与运动影像",
    description:
      "足球、篮球等主流赛事集锦与运动影像聚合，按赛事与时间整理，方便快速回看精彩瞬间与高光时刻。",
  },
  {
    id: "music",
    name: "音乐",
    icon: "ri-music-2-line",
    tagline: "演唱会与音乐现场",
    description:
      "演唱会、音乐现场与民谣弹唱等音乐内容聚合，梳理演出信息与曲目看点，便于按风格定位想听的现场。",
  },
  {
    id: "game",
    name: "游戏",
    icon: "ri-gamepad-line",
    tagline: "电竞与游戏文化",
    description:
      "电竞赛事、游戏文化与实况影像聚合，整理赛事与作品向内容，方便玩家了解最新动态与经典回顾。",
  },
];